//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";

// component
import MyPageProduct from "../../../../component/content/MyPageProduct";
import Pagination from "../../../../component/pagination/Pagination";
import MypageBtn from "../../../../component/button/MypageBtn";

// responsive
import { M, T } from "../../../../utils/MT";
// img
import more from "../../../../assets/img/icon/icon_more2.svg";

// testData
import { OrderListData } from "../../../../Data";

export default function MyOrder() {
    //페이지 이동
    const navigate = useNavigate();
    const orderDetailPage = () => {
        navigate(`/mypage/order_detail/0`);
    };

    return (
        <MyPageContent>
            {/* 타이틀 */}
            <MyPageTitleBox>
                <MyPageTitle>주문배송조회</MyPageTitle>
            </MyPageTitleBox>
            {OrderListData.length > 0 ? (
                <>
                    {OrderListData.map((list, index) => {
                        return (
                            <OrderTableWrap key={"orderList" + list.id}>
                                {/* 테이블 제목 */}
                                <PC>
                                    <TabelTitle>
                                        <TableList NotoR>
                                            주문일자 <span>{list.date}</span>
                                        </TableList>
                                        <TableList
                                            onClick={() => {
                                                orderDetailPage();
                                            }}
                                            cursorAble
                                            NotoR
                                        >
                                            주문번호 <span>{list.ordernum}</span>
                                            <MoreBtn>
                                                <img src={more} alt="아이콘" />
                                            </MoreBtn>
                                            {/* <MoreBtn onClick={ () => { console.log(list.id)}}><img src={more} alt="아이콘" /></MoreBtn> */}
                                        </TableList>
                                        <TableList>배송비</TableList>
                                        <TableList>진행상태</TableList>
                                    </TabelTitle>
                                </PC>

                                <Mobile>
                                    <TabelTitle>
                                        <TableList>
                                            <span>{list.date}</span>
                                        </TableList>
                                        <TableList
                                            onClick={() => {
                                                orderDetailPage(list.id);
                                            }}
                                        >
                                            <span>{list.ordernum}</span>
                                            <MoreBtn>
                                                <img src={more} alt="아이콘" />
                                            </MoreBtn>
                                        </TableList>
                                    </TabelTitle>
                                </Mobile>

                                <TableContentWrap>
                                    {/* 테이블 리스트 */}
                                    {list.orderlist.map((item, index) => {
                                        return (
                                            <OrderListBox key={index}>
                                                <MyPageProduct
                                                    id={item.id}
                                                    productImg={item.productImg}
                                                    itemName={item.itemName}
                                                    price={item.price}
                                                    num={item.num}
                                                    option={item.option}
                                                    i={item.id}
                                                />
                                                {item.delivery ? <DelText>{item.delivery} 원</DelText> : <DelText>무료배송</DelText>}
                                                <MypageBtn state={item.state} />
                                            </OrderListBox>
                                        );
                                    })}
                                </TableContentWrap>
                            </OrderTableWrap>
                        );
                    })}
                </>
            ) : (
                //  주문 내역이 없을때
                <NotOrderText>주문 내역이 없습니다.</NotOrderText>
            )}

            {/* 테이블 */}
            {/* 리스트가 5개 이상일시 페이지네이션 보여주세요! */}
            <PaginationWrap>
                <Pagination />
            </PaginationWrap>
        </MyPageContent>
    );
}

const MyPageContent = styled.section`
    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-bottom: calc(100vw * (19 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (19 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(19)};
    }
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const PaginationWrap = styled.div`
    margin-top: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(60)};
    }
`;
const OrderTableWrap = styled.article`
    margin-top: calc(100vw * (31 / 1920));

    &:first-of-type > ul:first-child {
        border-top: 0;
    }

    &:first-of-type {
        margin-top: 0;
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (31 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const TabelTitle = styled.ul`
    display: flex;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(15)} 0;
    }
`;
const TableList = styled.li`
    flex-shrink: 0;

    text-align: center;

    font-size: calc(100vw * (15 / 1920));

    &:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (180 / 1920));
    }
    &:nth-child(2) {
        display: flex;
        align-items: center;

        width: calc(100vw * (250 / 1920));
    }
    &:nth-child(3) {
        width: calc(100vw * (185 / 1920));
    }
    &:nth-child(4) {
        width: calc(100vw * (225 / 1920));
    }

    ${({ cursorAble }) => {
        return (
            cursorAble &&
            `
                cursor: pointer;
            `
        );
    }}

    ${({ NotoR }) => {
        return (
            NotoR &&
            `
                font-family: "Noto-R";
            `
        );
    }}

    & span {
        font-family: "Noto-M";
        margin-left: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        &:nth-child(1) {
            width: calc(100vw * (180 / 1300));
        }
        &:nth-child(2) {
            width: calc(100vw * (250 / 1300));
        }
        &:nth-child(3) {
            width: calc(100vw * (185 / 1300));
        }
        &:nth-child(4) {
            width: calc(100vw * (225 / 1300));
        }

        & span {
            margin-left: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        &:nth-child(1) {
            width: auto;
        }
        &:nth-child(2) {
            width: auto;
        }
        &:nth-child(3) {
            width: ${M(150)};
        }
        &:nth-child(4) {
            width: ${M(210)};
        }

        & span {
            margin-left: 0;
        }
    }
`;
const MoreBtn = styled.button`
    display: flex;
    align-items: center;

    width: calc(100vw * (10 / 1920));
    height: calc(100vw * (10 / 1920));
    margin-left: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (10 / 1300));
        height: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(10)};
        height: ${M(10)};
        margin-left: ${M(10)};
    }
`;
const NotOrderText = styled.p`
    margin: calc(100vw * (205 / 1920)) 0;
    font-size: calc(100vw * (15 / 1920));

    text-align: center;
    color: #aaaaaa;

    @media screen and (max-width: 1300px) {
        margin: calc(100vw * (205 / 1300)) 0;
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin: ${M(205)} 0;
        font-size: ${M(15)};
    }
`;
const TableContentWrap = styled.ul``;

const OrderListBox = styled.li`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (20 / 1920)) 0;

    & > div {
        flex-shrink: 0;
    }

    & > div:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (430 / 1920));
    }
    & > div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        width: calc(100vw * (185 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (225 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;

        & > div:nth-child(1) {
            width: calc(100vw * (430 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (185 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (225 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        align-items: unset;
        min-height: ${M(223)};

        padding: ${M(20)} ${M(0)} ${M(15)};

        & > div:nth-child(1) {
            width: 100%;
        }
        & > div:nth-child(2) {
            width: 100%;
            justify-content: unset;
        }
        & > div:nth-child(3) {
            width: auto;
            justify-content: flex-end;
            align-items: center;
            margin-left: auto;
        }
    }
`;

const DelText = styled.div`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        padding-left: ${M(97)};
        margin-top: ${M(10)};
    }
`;
